import React, { PropsWithChildren } from 'react';
import { MappedComponentProperties } from '@adobe/aem-react-editable-components';

import './Breadcrumbs.css';
import { cleanInternalLinkUrl } from '../../utils/cob-utils';
import { BreadcrumbsCL } from '../../importCL';
interface IDescriptionBullet {
    name: string;
    path: string;
}

interface ISingleString {
    value: string;
}


interface IBreadcrumbsProps extends MappedComponentProperties {
    className?: string;
    dynamic?: boolean;
    staticBreadcrumbs?: IDescriptionBullet[];
    wordsToLowerCase?: ISingleString[];
    wordsToUpperCase?: ISingleString[];
}

export const BreadcrumbsEditConfig = {
    emptyLabel: 'Breadcrumbs',
    isEmpty: (props: PropsWithChildren<IBreadcrumbsProps>) => {
        return !props || (props.dynamic === undefined);
    },
};

const Breadcrumbs = (props: PropsWithChildren<IBreadcrumbsProps>): JSX.Element => {
    const ignoredAuthorModeCrumbs = [
        { target: 'content', replace: '' },
        { target: 'cob-corp-acquisition', replace: '' },
        { target: 'us', replace: '' },
        { target: 'en', replace: '' },
        { target: 'corporate', replace: '' },
    ];

    const links = props.dynamic || !props.staticBreadcrumbs ? [] :
        props.staticBreadcrumbs.map(({ name, path }) => ({
            name,
            path: cleanInternalLinkUrl(path) || '/',
        }));

    const wordsToUpperCase = props.wordsToUpperCase?.map((item) => item.value);
    const wordsToLowerCase = props.wordsToLowerCase?.map((item) => item.value);
    return (
        <BreadcrumbsCL
            id='breadcrumbs'
            className={props.className}
            links={links}
            useUppercase={true}
            replaceCrumbs={[...ignoredAuthorModeCrumbs]}
            wordsToUpperCase={wordsToUpperCase}
            wordsToLowerCase={wordsToLowerCase}
        />
    );
};

export default Breadcrumbs;
